import {
  FETCH_COMPANIES, FETCH_COMPANIES_SUCCESS, FETCH_COMPANIES_FAILED,
  ADD_COMPANY, UPDATE_COMPANY, DELETE_COMPANY,
  FETCH_PRODUCTS, FETCH_PRODUCTS_SUCCESS, FETCH_PRODUCTS_FAILED,
  ADD_PRODUCT, UPDATE_PRODUCT, DELETE_PRODUCT,
  FETCH_COMPANY_STATES, FETCH_COMPANY_STATES_SUCCESS, FETCH_COMPANY_STATES_FAILED,
  ADD_COMPANY_STATE,
} from '../store/types';

const INITIAL_STATE = {
  companies: [],
  products: [],
  states: [],
  loading: false,
  productsLoading: false,
  statesLoading: false,
  error: { flag: false, msg: null },
};

export const businessreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPANIES:
      return { ...state, loading: true };
    case FETCH_COMPANIES_SUCCESS:
      return { ...state, loading: false, companies: action.payload };
    case FETCH_COMPANIES_FAILED:
      return { ...state, loading: false, error: { flag: true, msg: action.payload } };

    case ADD_COMPANY:
      return { ...state, companies: [...state.companies, action.payload] };
    case UPDATE_COMPANY:
      return {
        ...state,
        companies: state.companies.map(c =>
          c.id === action.payload.id ? { ...c, ...action.payload } : c
        ),
      };
    case DELETE_COMPANY:
      return { ...state, companies: state.companies.filter(c => c.id !== action.payload) };

    case FETCH_PRODUCTS:
      return { ...state, productsLoading: true };
    case FETCH_PRODUCTS_SUCCESS:
      return { ...state, productsLoading: false, products: action.payload.products };
    case FETCH_PRODUCTS_FAILED:
      return { ...state, productsLoading: false };

    case ADD_PRODUCT:
      return { ...state, products: [...state.products, action.payload] };
    case UPDATE_PRODUCT:
      return {
        ...state,
        products: state.products.map(p =>
          p.id === action.payload.id ? { ...p, ...action.payload } : p
        ),
      };
    case DELETE_PRODUCT:
      return { ...state, products: state.products.filter(p => p.id !== action.payload.productId) };

    case FETCH_COMPANY_STATES:
      return { ...state, statesLoading: true };
    case FETCH_COMPANY_STATES_SUCCESS:
      return { ...state, statesLoading: false, states: action.payload };
    case FETCH_COMPANY_STATES_FAILED:
      return { ...state, statesLoading: false };
    case ADD_COMPANY_STATE:
      return { ...state, states: [action.payload, ...state.states] };

    default:
      return state;
  }
};
